import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

const ErrorState = ({ message = "Something went wrong", onRetry }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.icon}>⚠️</Text>
      <Text style={styles.title}>Oops!</Text>
      <Text style={styles.message}>{message}</Text>
      {onRetry && (
        <TouchableOpacity style={styles.button} onPress={onRetry}>
          <Text style={styles.buttonText}>Try Again</Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 48,
    backgroundColor: '#FEF2F2',
    borderRadius: 12,
  },
  icon: {
    fontSize: 64,
    color: '#EF4444',
    marginBottom: 16,
  },
  title: {
    color: '#B91C1C',
    fontSize: 18,
    fontWeight: '500',
    marginBottom: 8,
  },
  message: {
    color: '#DC2626',
    textAlign: 'center',
    marginBottom: 16,
    maxWidth: 300,
  },
  button: {
    backgroundColor: '#EF4444',
    paddingHorizontal: 24,
    paddingVertical: 8,
    borderRadius: 8,
  },
  buttonText: {
    color: '#FFFFFF',
    fontWeight: '500',
  },
});

export default ErrorState; 